import styled, { css } from 'styled-components';
import { Button } from 'components/atoms/button';

export const CardFooter = styled.div`
  display: flex;
  border-top: 1px solid var(--gray-20);
  width: 100%;
  padding: var(--spacing-02) var(--spacing-04) var(--spacing-02)
    var(--spacing-05);
  align-items: center;
  justify-content: space-between;

  button.assignee-trigger {
    padding: 0px;
  }
`;

const ButtonPadding = css`
  padding-left: var(--spacing-03);
  padding-right: var(--spacing-03);
`;

export const CardFooterItem = styled.div`
  &.assignee-picker {
    width: 78px;
    button:not(.ant-btn-icon-only) {
      ${ButtonPadding};
    }
  }
  &.subtask_count {
    width: 95px;
    button {
      ${ButtonPadding};
    }
  }
  &.responsible_avatar {
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: default;
  }

  min-width: var(--spacing-06);
`;

export const SubTaskExpander = styled(Button)<{
  active?: boolean;
}>`
  background-color: ${(p) =>
    p.active ? 'var(--ozone-cool-gray-surface)' : ''};
`;
